interface RevealablePlayer {
  readonly selnNumber: number;
  readonly revealed: boolean;
}

export const revealTeamPlayer = <T extends RevealablePlayer>(selnNumber: number, team: T[]): T[] => {
  return team.map((player) => (player.selnNumber === selnNumber ? { ...player, revealed: true } : player));
};

export const allPlayersRevealed = (team: RevealablePlayer[]): boolean => {
  if (team.length === 0) return false;
  return team.every((player) => player.revealed);
};

export const getOppositionTeam = (teamCode: string, participants: Array<{ participantCode: string }>): string => {
  const participant = participants.find(({ participantCode }) => participantCode !== teamCode);
  return participant?.participantCode ?? '';
};

export const getReactAppNameEnv = () => process.env.REACT_APP_NAME;
